module.exports = __webpack_public_path__ + "static/img/21ca5baaabc667a6745892124bf70b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv3.png
// module id = r0L/
// module chunks = 1